export var elevation = {
    elevation0: '0px 0px 0px 2px #EEAFAF',
    elevation1: '0px 1px 0px rgba(0, 0, 0, 0.05)',
    elevation2: '0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 1px rgba(0, 0, 0, 0.25)',
    elevation3: '0px 2px 10px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.2)',
    elevation4: '0px 4px 20px rgba(0, 0, 0, 0.15), 0px 0px 3px rgba(0, 0, 0, 0.1)',
    elevation5: '0px 8px 40px rgba(0, 0, 0, 0.2), 0px 0px 4px rgba(0, 0, 0, 0.1)'
};
